import styled, { css } from "styled-components";
import {
  BORDER_COLORS,
  COLORS,
  LAYER_COLORS,
  TEXT_COLORS,
} from "../../constants/design/colors";
import { FONT_CSS } from "../../constants/design/fontSize";
import {
  BORDER_RADIUS,
  SPACING,
  WIDTHS,
} from "../../constants/design/spacing";

// ── Card view (<= WIDTHS.M): 1 column on phones (<= WIDTHS.S), 2-col grid on tablet ──
export const PositionCardList = styled.div`
  display: grid;
  grid-template-columns: 1fr;
  align-content: start;
  gap: ${SPACING.three}px;
  padding: ${SPACING.three}px;
  overflow-y: auto;
  height: 100%;

  /* Tablet (> WIDTHS.S, still card view): two cards per row. */
  @media (min-width: ${WIDTHS.S + 1}px) {
    grid-template-columns: 1fr 1fr;
  }
`;

export const PositionCard = styled.div<{ $isLong?: boolean }>`
  background-color: ${LAYER_COLORS.one};
  border: 1px solid ${BORDER_COLORS.two};
  border-radius: ${BORDER_RADIUS.three}px;
  padding: ${SPACING.three}px;
  cursor: pointer;

  /* Side indicator: identical to the desktop row — 2px left bar + a left→right
     gradient fading over the same 120px so long/short reads consistently. */
  ${({ $isLong }) =>
    $isLong !== undefined &&
    css`
      border-left: 2px solid
        ${$isLong ? COLORS.up.one : COLORS.down.one};
      background-image: linear-gradient(
        to right,
        ${$isLong ? COLORS.up.three : COLORS.down.three},
        transparent 120px
      );
    `}
`;

export const PositionCardHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: ${SPACING.three}px;
`;

export const PositionCardCoin = styled.div`
  ${FONT_CSS.body.five}
  display: flex;
  align-items: center;
  gap: ${SPACING.two}px;
  font-weight: 600;
`;

export const PositionCardLev = styled.span`
  ${FONT_CSS.label.two}
  color: ${TEXT_COLORS.three};
  background: ${LAYER_COLORS.two};
  padding: 1px ${SPACING.one}px;
  border-radius: 4px;
`;

export const PositionCardPnl = styled.div`
  ${FONT_CSS.body.five}
  display: flex;
  align-items: baseline;
  gap: ${SPACING.one}px;

  > span {
    ${FONT_CSS.label.two}
  }
`;

export const PositionCardGrid = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: ${SPACING.two}px ${SPACING.four}px;
`;

export const PositionCardField = styled.div`
  ${FONT_CSS.label.two}
  display: flex;
  align-items: center;
  justify-content: space-between;

  > span:first-child {
    color: ${TEXT_COLORS.three};
  }
  > span:last-child {
    color: ${TEXT_COLORS.one};
  }
`;

export const PositionCardFooter = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-top: ${SPACING.three}px;
`;

export const PositionCardCloseBtn = styled.button`
  ${FONT_CSS.label.two}
  padding: ${SPACING.two}px ${SPACING.four}px;
  border-radius: ${BORDER_RADIUS.two}px;
  border: 1px solid ${BORDER_COLORS.two};
  background: ${LAYER_COLORS.two};
  color: ${TEXT_COLORS.one};
  cursor: pointer;
`;

export const PositionCardTpsl = styled.div<{ $interactive?: boolean }>`
  ${FONT_CSS.label.two}
  color: ${TEXT_COLORS.three};
  background: transparent;
  border: none;
  padding: 0;
  cursor: ${({ $interactive }) => ($interactive ? "pointer" : "default")};

  > span {
    color: ${TEXT_COLORS.two};
    margin-left: ${SPACING.one}px;
  }
`;

export const PositionCardLoadMore = styled.button`
  ${FONT_CSS.label.two}
  grid-column: 1 / -1;
  color: ${TEXT_COLORS.two};
  padding: ${SPACING.two}px;
  background: transparent;
  border: none;
  cursor: pointer;
`;
